import { styled } from '@noshiro/goober';
export const MuiDivider = styled('hr') `
  border: none;
  height: 1px;
  margin: 0;
  flex-shrink: 0;
  background-color: rgba(0, 0, 0, 0.12);
`;
